import { forwardRef } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import Tabs from 'components/Tabs'

import style from './Build.style'
import Button from '../Button'

const BuildStyled = styled.div(props => ({ ...style(props) }))

const Build = forwardRef(({ title, titleTag: TitleTag, subtitle, text, tabsData, buttonText, buttonLink }, ref) => {
    return (
        <BuildStyled ref={ref}>
            <div className="BuildContainer">
                <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title }} />
                <div className="BlockCaption">
                    {subtitle && <p className="Subtitle">{subtitle}</p>}
                    {text && <p className="Text">{text}</p>}
                </div>
                <Tabs data={tabsData} />
                <div className="CtaContainer">
                    {buttonLink && (
                        <Button
                            dataAttrs={{
                                'gtm-event': 'link',
                                'gtm-label': 'Build',
                                'gtm-action': 'Enquire',
                                'gtm-category': 'Enquire'
                            }}
                            small
                            white
                            variation="primary rounded"
                            link={buttonLink}>
                            {buttonText}
                        </Button>
                    )}
                </div>
            </div>
        </BuildStyled>
    )
})

Build.propTypes = {
    title: PropTypes.string,
    titleTag: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    tabsData: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            title: PropTypes.string,
            content: PropTypes.string,
            image: PropTypes.string
        })
    ),
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string
}

Build.defaultProps = {
    titleTag: 'p',
    title: null,
    text: null,
    tabsData: [],
    subtitle: null,
    buttonText: null,
    buttonLink: null
}

export default withTheme(Build)
